module.exports = __webpack_public_path__ + "img/54dea63.jpg";